import React, { useState } from "react";
import { StyleSheet } from "react-native";
import { Image } from "expo-image";

import ImageLoadingAnimation from "./ImageLoadingAnimation";

import BorderLayout from "@/Components/Layouts/Native/BorderLayout";

interface ImageLoadingProps {
  imageUrl: string;
  width: number;
  height: number;
  borderRadiusTop?: number;
  borderRadiusBottom?: number;
}

function UserImageLoading({
  imageUrl,
  width,
  height,
  borderRadiusTop = 8,
  borderRadiusBottom = 8,
}: ImageLoadingProps): React.JSX.Element {
  const [isImageLoading, setIsImageLoading] = useState(true);

  const handleImageLoad = (): void => {
    setIsImageLoading(false);
  };

  return (
    <BorderLayout
      width={width}
      height={height}
      radiusTop={borderRadiusTop}
      radiusBottom={borderRadiusBottom}
    >
      {isImageLoading && <ImageLoadingAnimation width={width} />}
      <Image
        key={imageUrl}
        source={{ uri: imageUrl }}
        style={StyleSheet.absoluteFillObject}
        onLoad={handleImageLoad}
        contentFit="cover"
        transition={300}
        cachePolicy="memory-disk"
      />
    </BorderLayout>
  );
}

export default UserImageLoading;
